export function isMarketingEmailAsset(asset) {
  return asset.portableType === 'marketing-email';
}
export function isListAsset(asset) {
  return asset.portableType === 'object-lists';
}
export function isFormAsset(asset) {
  return asset.portableType === 'forms';
}
export function isWorkflowAsset(asset) {
  return asset.portableType === 'workflows';
}